import { useState } from 'react';
import styled from 'styled-components';
import { FontsPage } from './FontsPage';
import { ImagesPage } from './ImagesPage';

export const AssetsDrawer = () => {
  const [page, setPage] = useState<'images' | 'fonts'>('images');

  const drawPage = () => {
    switch (page) {
      case 'images':
        return <ImagesPage />;
      case 'fonts':
        return <FontsPage />;
    }
  };

  return (
    <Container>
      <PageButtonsContainer>
        <PageButton $isActive={page === 'images'} onClick={() => setPage('images')}>
          Images
        </PageButton>
        <PageButton $isActive={page === 'fonts'} onClick={() => setPage('fonts')}>
          Fonts
        </PageButton>
      </PageButtonsContainer>
      {drawPage()}
    </Container>
  );
};

const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: calc(100vh - 58px);

  display: flex;
  flex-direction: column;
`;

const PageButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: var(--padding-1);
  padding: var(--padding-1);
`;

const PageButton = styled.div<{ $isActive?: boolean }>`
  cursor: pointer;
  padding: 5px 10px;
  border-radius: var(--radius-2);
  background-color: var(--neutral-2);
  color: var(--main-2);
  font-size: 12px;

  transition:
    background-color 0.3s ease,
    color 0.3s ease,
    opacity 0.3s ease;

  &:hover {
    background-color: var(--neutral-3);
    color: var(--main-1);
  }

  ${({ $isActive }) =>
    $isActive &&
    `
    background-color: var(--neutral-3);
    color: var(--main-1);
    &:hover {
      background-color: var(--neutral-3);
      color: var(--main-1);
    }
  `}
`;
